import { Button, Form, Input } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import styled from 'styled-components';
import { createElement, ChangeEvent, Component, Props as ReactProps, MouseEvent } from 'react';
import SignupUser from '../../../../entity/signupUser';

type Props = ReactProps<HTMLSpanElement> & {
  signupUser: SignupUser
  updateSignupUserField: (partial: Partial<SignupUser>) => void;
  onClickSignupButton: () => void;
};
type State = {
  confirmDirty: boolean;
}

const StyledForm = styled(Form)`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledInput = styled(Input)`
  margin-bottom: 16px;
`;

const StyledFormItem = styled(Form.Item)<any>`
  margin-bottom: 0 !important;
  width: 100%;
  max-width: 400px;
`;

class SignupUserForm extends Component<Props & FormComponentProps, State> {
  constructor(props: Props & FormComponentProps) {
    super(props);

    this.state = {
      confirmDirty: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateToNextPassword = this.validateToNextPassword.bind(this);
    this.compareToFirstPassword = this.compareToFirstPassword.bind(this);
  }

  public render() {
    const {
      signupUser,
      updateSignupUserField,
    } = this.props;
    const { getFieldDecorator } = this.props.form;

    return (
      <StyledForm>
        <StyledFormItem label="お名前">
          {
            getFieldDecorator('name', {
                rules: [
                  {
                    required: true,
                    message: '必須項目です。',
                  },
                ],
                initialValue: signupUser.name,
              }
            ) (
              <StyledInput
                onChange={(e: ChangeEvent<HTMLInputElement>) => updateSignupUserField({ name: e.target.value })}
                placeholder="デリバリー 太郎"
              />
            )
          }
        </StyledFormItem>
        <StyledFormItem label="ふりがな">
          {
            getFieldDecorator('phonetic', {
                rules: [
                  {
                    required: true,
                    message: '必須項目です。',
                  },
                ],
                initialValue: signupUser.phonetic,
              }
            ) (
              <StyledInput
                onChange={(e: ChangeEvent<HTMLInputElement>) => updateSignupUserField({ phonetic: e.target.value })}
                placeholder="でりばりー たろう"
              />
            )
          }
        </StyledFormItem>
        <StyledFormItem label="電話番号">
          {
            getFieldDecorator('phone', {
                rules: [
                  {
                    required: true,
                    message: '必須項目です。',
                  },
                ],
                initialValue: signupUser.phone,
              }
            ) (
              <StyledInput
                onChange={(e: ChangeEvent<HTMLInputElement>) => updateSignupUserField({ phone: e.target.value })}
                placeholder="0000000000(半角数字のみ)"
              />
            )
          }
        </StyledFormItem>
        <StyledFormItem label="都道府県">
          <StyledInput
            onChange={(e: ChangeEvent<HTMLInputElement>) => updateSignupUserField({ region: e.target.value })}
            placeholder="東京都"
          />
        </StyledFormItem>
        <StyledFormItem label="市区町村">
          <StyledInput
            onChange={(e: ChangeEvent<HTMLInputElement>) => updateSignupUserField({ city: e.target.value })}
            placeholder="港区"
          />
        </StyledFormItem>
        <StyledFormItem label="住所">
          <StyledInput
            onChange={(e: ChangeEvent<HTMLInputElement>) => updateSignupUserField({ address1: e.target.value })}
            placeholder="〇〇町〇ー〇ー〇"
          />
        </StyledFormItem>
        <StyledFormItem label="建物名以下">
          <StyledInput
            onChange={(e: ChangeEvent<HTMLInputElement>) => updateSignupUserField({ address2: e.target.value })}
            placeholder="〇〇ビル"
          />
        </StyledFormItem>
        <StyledFormItem label="パスワード">
          {
            getFieldDecorator('password', {
                rules: [
                  {
                    min: 8,
                    max: 32,
                    message: 'パスワードは8文字から32文字です。',
                  },
                  {
                    validator: this.validateToNextPassword,
                  },
                  {
                    required: true,
                    message: '必須項目です。',
                  },
                ],
                initialValue: signupUser.password,
              }
            ) (
              <StyledInput
                type="password"
                onChange={(e: ChangeEvent<HTMLInputElement>) => updateSignupUserField({ password: e.target.value })}
                placeholder="小文字英数字の8−32桁"
              />
            )
          }
        </StyledFormItem>
        <StyledFormItem label="確認パスワード">
          {
            getFieldDecorator('passwordConfirmation', {
                rules: [
                  {
                    validator: this.compareToFirstPassword,
                  },
                  {
                    required: true,
                    message: '必須項目です。',
                  },
                ],
                initialValue: signupUser.passwordConfirmation,
              }
            ) (
              <StyledInput
                type="password"
                onChange={(e: ChangeEvent<HTMLInputElement>) => updateSignupUserField({ passwordConfirmation: e.target.value })}
                placeholder="パスワードと同じものを入力してください。"
              />
            )
          }
        </StyledFormItem>

        <StyledFormItem>
          <Button type="primary" htmlType="submit" onClick={this.handleSubmit}>
            登録する
          </Button>
        </StyledFormItem>
      </StyledForm>
    );
  }

  private handleSubmit(e: MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    this.props.form.validateFields((err) => {
      if (!err) {
        this.props.onClickSignupButton();
      }
    });
  };

  private validateToNextPassword(_: any, value: any, callback: any) {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  private compareToFirstPassword(_: any, value: any, callback: any) {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('入力したパスワードが一致していません。');
    } else {
      callback();
    }
  };
}

export default Form.create<Props & FormComponentProps>()(SignupUserForm);
